import { render } from "./Introscherm1.vue?vue&type=template&id=4b0d7122&ts=true"
import script from "./Introscherm1.vue?vue&type=script&lang=ts"
export * from "./Introscherm1.vue?vue&type=script&lang=ts"

import "./Introscherm1.vue?vue&type=style&index=0&id=4b0d7122&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__